import { createContext, ReactNode, use } from 'react';

interface RequestContextValue {
    host: string | null;
    protocol: string | null;
}

export const RequestContext = createContext<RequestContextValue>({
    host: typeof window !== 'undefined' ? window.location.host : null,
    protocol: typeof window !== 'undefined' ? window.location.protocol : null,
});

export function useRequestContext() {
    const context = use(RequestContext);
    return context;
}

export function useRequestHost() {
    const { host } = useRequestContext();
    return host;
}

export function useRequestProtocol() {
    const { protocol } = useRequestContext();
    return protocol;
}

export function useRequestBase() {
    const { protocol, host } = useRequestContext();
    return `${(protocol || 'https:').replace(/:$/, '')}://${host || 'urbania.ca'}`;
}

interface RequestContextProviderProps {
    host?: string | null;
    protocol?: string | null;
    children?: ReactNode;
}

export function RequestContextProvider({
    host = null,
    protocol = null,
    children = null,
}: RequestContextProviderProps) {
    return (
        <RequestContext
            value={{
                host,
                protocol,
            }}
        >
            {children}
        </RequestContext>
    );
}
